/**
 * Representa os tipos de falhas logísticas que podem ocorrer durante o processo de transporte.
 *
 * @enum {number}
 * @property {0} PICKUP   - Indica uma falha na coleta do pedido.
 * @property {1} DELIVERY - Indica uma falha na entrega do pedido.
 */
export enum LogisticsFailureType {
  PICKUP = 0,
  DELIVERY = 1,
}

export type LogisticsFailureReason = {
  type: LogisticsFailureType;
  typeDescription: string;
  microStatus: string;
  description: string;
};
